import React from "react";
import * as S from "./Faq.styles";

interface faqProps {
  faqHeading: string,
  faqData: Array<props>;
}

interface props {
  a: string;
  q: string;
}

const Faq: React.FC<faqProps> = ({ faqHeading = "", faqData = [] }) => {
  if (!(faqData?.length)) return null;
  return (
    <S.Wrapper itemScope itemType="https://schema.org/FAQPage">
      {faqHeading && <S.Title>{faqHeading}</S.Title>}
      <S.ContentWrapper>
        <div>
          {faqData?.map(({ a = '', q = '' }, index) => (
            <div className={index !== faqData?.length - 1 ? "padB25" : ""} key={`Faq${index}`} itemProp="mainEntity" itemScope itemType="https://schema.org/Question">
              <S.Question>
                <h3 itemProp="name">{`Q: ${q}`}</h3>
              </S.Question>
              <S.Answer itemProp="acceptedAnswer" itemScope itemType="https://schema.org/Answer">
                <p itemProp="text" dangerouslySetInnerHTML={{ __html: a }} />
              </S.Answer>
            </div>
          ))}
        </div>
      </S.ContentWrapper>
    </S.Wrapper>
  );
};
export default Faq;
